let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dBH64")).then(() => parcelRequire('aUZ4r'));